import { buildApiUrl, ADMIN_ENDPOINTS } from '../../configs/api.js'

export default {
  url(payload) {
    return buildApiUrl(ADMIN_ENDPOINTS.DASHBOARD_STATS, {
      queryParams: {
        startDate: payload?.startDate,
        endDate: payload?.endDate
      }
    })
  },

  parse(raw = {}, payload = {}) {
    if (!raw.success) {
      return {
        statusCode: raw?.statusCode || 400,
        message: raw?.message || 'Failed to fetch dashboard stats',
        data: null,
      }
    }

    // Le backend V3 renvoie déjà la structure attendue par le dashboard
    // { overview: {...}, orders: {...}, revenue: {...} }
    const stats = raw.data || {}

    return {
      statusCode: 200,
      message: 'Ok',
      data: {
        ...stats,
        // On s'assure que les champs attendus par le UI sont là ou mappés
        recentActivities: stats.recentActivities || [],
        performanceMetrics: stats.performanceMetrics || []
      },
    }
  },
}
